<!-- Modal Container -->
<template>
  <transition name="modal-fade" class="modal-fade">
    <div class="modal-backdrop">
      <form  action="#"  method="post">
      <div class="reengagement-report" role="dialog" aria-labelledby="modalTitle" aria-describedby="modalDescription">
        <header class="modal-header">
          <slot name="header">           
            <i class="fa fa-bar-chart report-icon" aria-hidden="true"></i>&nbsp;&nbsp;{{title}}
            <div class="closeButton">
            </div>
          </slot>
        </header>
        <section class="reengagement-report-body">
          <div class="row">
            <div class="col-xl-3 col-md-6 mb-4">
                <div class="card border-left-green shadow py-2">
                    <div class="card-body">
                        <div class="row no-gutters align-items-center">
                            <div class="col mr-2">
                                <div class="text-sm font-weight-bold text-green text-uppercase mb-1">
                                    Estimated Audience*</div>
                                <div class="heading-style text-lg mb-0 font-weight-bold text-gray-800">{{reengagementReport.estimatedAudienceCount}}</div>
                            </div>
                            <div class="col-auto">
                                <i class="fas fa-dollar-sign fa-2x text-gray-300"></i>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </div>
					<div class="text-red">*Some users may be excluded at reengagement runtime.</div>

					<div class="campaign-details margin-top-20">
						<div>Reengagement Name: <span class="campaign-details-text">{{this.campaignDetails.campaign_name ? this.campaignDetails.campaign_name : '-'}}</span></div>
						<div>Country: <span class="campaign-details-text">{{this.campaignDetails.country ? this.campaignDetails.country : '-'}}</span></div>
						<div>Type: <span class="campaign-details-text">{{this.campaignDetails.campaign_type ? this.campaignDetails.campaign_type : '-'}}</span></div>
						<div>Audience: <span class="campaign-details-text">{{this.campaignDetails.audience_name ? this.campaignDetails.audience_name : '-'}}</span></div>
					</div>
					<div class="campaign-group-details">
						<div class="campaign-group-container border-left-rose" v-for="(item, index) in this.campaignDetails.group_list" :key="index">
							<div>Group Name: <span class="campaign-details-text">{{item.group_name ? item.group_name : '-'}}</span></div>
							<div>Nudge: <span class="campaign-details-text">{{item.msg_template_name ? item.msg_template_name : '-'}}</span></div>
							<div v-if="item.conversation">Conversation: <span class="campaign-details-text">{{item.conversation ? item.conversation : '-'}}</span></div>
							<div v-else>Keyword: <span class="campaign-details-text">{{item.keyword ? item.keyword : '-'}}</span></div>
							<div>Destination: <span class="campaign-details-text">{{item.destination_app_name ? item.destination_app_name : '-'}}</span></div>
							<div>Split Percent: <span class="campaign-details-text">{{item.split_percent || item.split_percent === 0 ? item.split_percent + '%' : '-'}}</span></div>
						</div>
					</div>
        </section>
        <footer class="modal-footer">
            <slot name="footer">
              <button type="button" class="btn btn-primary" @click="close">Close</button>
            </slot>
        </footer>
      </div>
      </form>
    </div>
  </transition>
  <!-- Modal Container end -->
</template>
<script>
  export default {
    name: 'modal',
    props: [ 'reengagementReport', 'campaignDetails' ],
    data () {
      return {
        title: 'Reengagement Report'
      }
    },
    methods: {
      close () {
        console.log('closing the modal')
        this.$emit('close')
      }
    }
  }
</script>
<style>
/* @import './../../assets/admin-lte.css'; */
</style>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.campaign-details-text {
	font-weight: normal;
  margin-left: 8px;
	word-break: break-all;
}
.campaign-details {
	display: flex;
	flex-direction: column;
	font-weight: bold;
}
.margin-top-20 {
	margin-top: 20px;
}
.card {
	position: relative;
	display: flex;
	flex-direction: column;
	min-width: 0;
	word-wrap: break-word;
	background-color: #fff;
	background-clip: border-box;
	border: 1px solid #e3e6f0;
	border-radius: .35rem
}

.card>hr {
	margin-right: 0;
	margin-left: 0
}

.card>.list-group {
	border-top: inherit;
	border-bottom: inherit
}

.card>.list-group:first-child {
	border-top-width: 0;
	border-top-left-radius: calc(.35rem - 1px);
	border-top-right-radius: calc(.35rem - 1px)
}

.card>.list-group:last-child {
	border-bottom-width: 0;
	border-bottom-right-radius: calc(.35rem - 1px);
	border-bottom-left-radius: calc(.35rem - 1px)
}

.card>.card-header+.list-group,
.card>.list-group+.card-footer {
	border-top: 0
}

.card-body {
	flex: 1 1 auto;
	min-height: 1px;
	padding: 1.25rem
}

.card-title {
	margin-bottom: .75rem
}

.card-subtitle {
	margin-top: -.375rem;
	margin-bottom: 0
}

.card-text:last-child {
	margin-bottom: 0
}

.card-link:hover {
	text-decoration: none
}

.card-link+.card-link {
	margin-left: 1.25rem
}

.card-header {
	padding: .75rem 1.25rem;
	margin-bottom: 0;
	background-color: #f8f9fc;
	border-bottom: 1px solid #e3e6f0
}

.card-header:first-child {
	border-radius: calc(.35rem - 1px) calc(.35rem - 1px) 0 0
}

.card-footer {
	padding: .75rem 1.25rem;
	background-color: #f8f9fc;
	border-top: 1px solid #e3e6f0
}

.card-footer:last-child {
	border-radius: 0 0 calc(.35rem - 1px) calc(.35rem - 1px)
}

.card-header-tabs {
	margin-right: -.625rem;
	margin-bottom: -.75rem;
	margin-left: -.625rem;
	border-bottom: 0
}

.card-header-pills {
	margin-right: -.625rem;
	margin-left: -.625rem
}

.card-img-overlay {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	padding: 1.25rem;
	border-radius: calc(.35rem - 1px)
}

.card-img,
.card-img-bottom,
.card-img-top {
	flex-shrink: 0;
	width: 100%
}

.card-img,
.card-img-top {
	border-top-left-radius: calc(.35rem - 1px);
	border-top-right-radius: calc(.35rem - 1px)
}

.card-img,
.card-img-bottom {
	border-bottom-right-radius: calc(.35rem - 1px);
	border-bottom-left-radius: calc(.35rem - 1px)
}

.card-deck .card {
	margin-bottom: .75rem
}
  .modal-backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .reengagement-report {
    background: #FFFFFF;
    box-shadow: 2px 2px 20px 1px;
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    position:absolute;
    top:50%;
    left:50%;
    transform: translate(-50%,-50%);    
    width: 700px;
    padding: 20px;
  }

  .modal-header,
  .modal-footer {
    padding: 15px;
    display: inline-block;
  }

  .modal-header {
    border-bottom: 1px solid #eeeeee;
    text-align: center;
    font-size: 18px;
  }

  .modal-footer {
    border-top: 1px solid #eeeeee;
    justify-content: flex-end;
  }

  .reengagement-report-body {
    position: relative;
    padding: 20px 10px;
    min-height: 70px;
		max-height: 500px;
		overflow-y: auto;
		overflow-x: hidden;
  }

  .btn-close {
    border: none;
    font-size: 20px;
    padding: 20px;
    cursor: pointer;
    font-weight: bold;
    color: #0D9488;
    background: transparent;
  }

  .btn-green {
    color: white;
    background: #0D9488;
    border: 1px solid #0D9488;
    border-radius: 2px;
  }
  .modal-fade-enter,
  .modal-fade-leave-active {
    opacity: 0;
  }

  .modal-fade-enter-active,
  .modal-fade-leave-active {
    transition: opacity .5s ease
  }
  .closeButton {
    position:absolute;
    left:92%;
    top:-1%;
    font-weight: bold;
  }
  .text-red {
    color: red
  }
  .text-gray-100 {
	color: #f8f9fc!important
}
.text-xs {
	font-size: 10px;
}
.text-sm {
	font-size: 15px;
}
.text-md {
	font-size: 20px;
}
.text-lg {
	font-size: 25px;
}
.text-gray-200 {
	color: #eaecf4!important
}

.text-gray-300 {
	color: #dddfeb!important
}

.text-gray-400 {
	color: #d1d3e2!important
}

.text-gray-500 {
	color: #b7b9cc!important
}

.text-gray-600 {
	color: #8896A5!important
}

.text-gray-700 {
	color: #5C6E8A!important
}

.text-gray-800 {
	color: #2D3748!important
}

.text-gray-900 {
	color: #1E3A5F!important
}
.no-gutters {
	margin-right: 0;
	margin-left: 0
}

.no-gutters>.col,
.no-gutters>[class*=col-] {
	padding-right: 0;
	padding-left: 0
}

.mb-0,
.my-0 {
	margin-bottom: 0!important
}
.border-left-primary {
	border-left: .25rem solid #1E3A5F!important
}

.border-bottom-primary {
	border-bottom: .25rem solid #1E3A5F!important
}

.border-left-secondary {
	border-left: .25rem solid #8896A5!important
}

.border-bottom-secondary {
	border-bottom: .25rem solid #8896A5!important
}

.border-left-green {
	border-left: .4rem solid #0D9488!important
}

.border-bottom-green {
	border-bottom: .25rem solid #0D9488!important
}

.border-left-blue {
	border-left: .4rem solid #1E3A5F!important
}

.border-bottom-blue {
	border-bottom: .25rem solid #1E3A5F!important
}

.border-left-purple {
	border-left: .4rem solid #9932CC!important
}

.border-bottom-purple {
	border-bottom: .25rem solid #9932CC!important
}

.border-left-warning {
	border-left: .25rem solid #f6c23e!important
}

.border-bottom-warning {
	border-bottom: .25rem solid #f6c23e!important
}

.border-left-danger {
	border-left: .25rem solid #E05263!important
}

.border-bottom-danger {
	border-bottom: .25rem solid #E05263!important
}

.border-left-light {
	border-left: .25rem solid #f8f9fc!important
}

.border-bottom-light {
	border-bottom: .25rem solid #f8f9fc!important
}

.border-left-dark {
	border-left: .25rem solid #2D3748!important
}

.border-bottom-dark {
	border-bottom: .25rem solid #2D3748!important
}

.progress-sm {
	height: .5rem
}
.font-weight-light {
	font-weight: 300!important
}

.font-weight-lighter {
	font-weight: lighter!important
}

.font-weight-normal {
	font-weight: 400!important
}

.font-weight-bold {
	font-weight: 700!important
}

.font-weight-bolder {
	font-weight: bolder!important
}

.font-italic {
	font-style: italic!important
}

.text-white {
	color: #fff!important
}

.text-primary {
	color: #1E3A5F!important
}

a.text-primary:focus,
a.text-primary:hover {
	color: #172E4C!important
}

.text-secondary {
	color: #8896A5!important
}

a.text-secondary:focus,
a.text-secondary:hover {
	color: #60616f!important
}

.text-green {
	color: #0D9488!important
}

a.text-green:focus,
a.text-green:hover {
	color: #0B7C72!important
}

.text-blue {
	color: #1E3A5F!important
}

a.text-blue:focus,
a.text-blue:hover {
	color: #258391!important
}

.text-purple {
	color: #9932CC!important
}

a.text-purple:focus,
a.text-purple:hover {
	color: #9932CC!important
}

.text-danger {
	color: #E05263!important
}
.chart-pie {
	position: relative;
	height: 15rem;
	width: 100%
}

@media (min-width:768px) {
	.chart-pie {
		height: calc(20rem - 43px)!important
	}
}
.dropdown-menu {
	position: absolute;
	top: 100%;
	left: 0;
	z-index: 1000;
	display: none;
	float: left;
	min-width: 10rem;
	padding: .5rem 0;
	margin: .125rem 0 0;
	font-size: .85rem;
	color: #8896A5;
	text-align: left;
	list-style: none;
	background-color: #fff;
	background-clip: padding-box;
	border: 1px solid #e3e6f0;
	border-radius: .35rem
}

.dropdown-menu-left {
	right: auto;
	left: 0
}

.dropdown-menu-right {
	right: 0;
	left: auto
}

@media (min-width:576px) {
	.dropdown-menu-sm-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-sm-right {
		right: 0;
		left: auto
	}
}

@media (min-width:768px) {
	.dropdown-menu-md-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-md-right {
		right: 0;
		left: auto
	}
}

@media (min-width:992px) {
	.dropdown-menu-lg-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-lg-right {
		right: 0;
		left: auto
	}
}

@media (min-width:1200px) {
	.dropdown-menu-xl-left {
		right: auto;
		left: 0
	}
	.dropdown-menu-xl-right {
		right: 0;
		left: auto
	}
}

.dropup .dropdown-menu {
	top: auto;
	bottom: 100%;
	margin-top: 0;
	margin-bottom: .125rem
}

.dropup .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: 0;
	border-right: .3em solid transparent;
	border-bottom: .3em solid;
	border-left: .3em solid transparent
}

.dropup .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-menu {
	top: 0;
	right: auto;
	left: 100%;
	margin-top: 0;
	margin-left: .125rem
}

.dropright .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: 0;
	border-bottom: .3em solid transparent;
	border-left: .3em solid
}

.dropright .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropright .dropdown-toggle::after {
	vertical-align: 0
}

.dropleft .dropdown-menu {
	top: 0;
	right: 100%;
	left: auto;
	margin-top: 0;
	margin-right: .125rem
}

.dropleft .dropdown-toggle::after {
	display: inline-block;
	margin-left: .255em;
	vertical-align: .255em;
	content: ""
}

.dropleft .dropdown-toggle::after {
	display: none
}

.dropleft .dropdown-toggle::before {
	display: inline-block;
	margin-right: .255em;
	vertical-align: .255em;
	content: "";
	border-top: .3em solid transparent;
	border-right: .3em solid;
	border-bottom: .3em solid transparent
}

.dropleft .dropdown-toggle:empty::after {
	margin-left: 0
}

.dropleft .dropdown-toggle::before {
	vertical-align: 0
}

.dropdown-menu[x-placement^=bottom],
.dropdown-menu[x-placement^=left],
.dropdown-menu[x-placement^=right],
.dropdown-menu[x-placement^=top] {
	right: auto;
	bottom: auto
}

.dropdown-divider {
	height: 0;
	margin: .5rem 0;
	overflow: hidden;
	border-top: 1px solid #eaecf4
}

.dropdown-item {
	display: block;
	width: 100%;
	padding: .25rem 1.5rem;
	clear: both;
	font-weight: 400;
	color: #1E3A5F;
	text-align: inherit;
	white-space: nowrap;
	background-color: transparent;
	border: 0
}

.dropdown-item:focus,
.dropdown-item:hover {
	color: #2e2f37;
	text-decoration: none;
	background-color: #eaecf4
}

.dropdown-item.active,
.dropdown-item:active {
	color: #fff;
	text-decoration: none;
	background-color: #1E3A5F
}

.dropdown-item.disabled,
.dropdown-item:disabled {
	color: #b7b9cc;
	pointer-events: none;
	background-color: transparent
}

.dropdown-menu.show {
	display: block
}

.dropdown-header {
	display: block;
	padding: .5rem 1.5rem;
	margin-bottom: 0;
	font-size: .875rem;
	color: #8896A5;
	white-space: nowrap
}

.dropdown-item-text {
	display: block;
	padding: .25rem 1.5rem;
	color: #1E3A5F
}

.text-uppercase {
	text-transform: uppercase!important
}
.report-icon {
  color:  #1E3A5F!important;
  font-size: 26px;
}
.campaign-group-details {
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
	font-weight: bold;
}

.campaign-group-details .campaign-group-container {
  list-style: none;
  flex: 0 0 31%;
	border: 1px solid #e3e6f0;
	border-radius: 4px;
	margin: 10px 10px 0px 0px;
	padding: 10px;
}

.border-left-rose {
	border-left: .4rem solid #f8b9d9 !important;
}
</style>


// WEBPACK FOOTER //
// scheduledReport.vue?2fb05c74